import React, { FC, FormEventHandler } from 'react';

interface IOpenInAppFormProps {
  appUri: string;
  urlSearchParams: URLSearchParams;
}

export const OpenInAppForm: FC<IOpenInAppFormProps> = ({ appUri, children, urlSearchParams }) => {
  const onSubmit: FormEventHandler = event => {
    event.preventDefault();
    const deepLinkUri = `${appUri}?${urlSearchParams}`;
    window.location.replace(deepLinkUri);
  };

  return (
    <form data-testid="continue-in-app-form" onSubmit={onSubmit}>
      {children}
    </form>
  );
};
